// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5987":"5242b93753d5e68b","6479":"c1c6e030078d2ce6"}[chunkId] + ".js";
};